// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + ({"12":"profiler","777":"recorder"}[chunkId] || chunkId) + "." + {"12":"04ca2821","453":"3529fa71","777":"f34f0d6c"}[chunkId] + ".chunk.js";
};